import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { SelectInput } from "../../../../common/form";
import { FormattedMessage, intlShape } from "react-intl";

import { BILLING_PERIODS } from "../../../../../utils/data/models";
import * as dataActions from "../../../../../utils/data/dataActions";

import validationUtils from "../../../../../utils/ValidationUtils";
import { INVOICES_VALIDATION_RULES } from "./invoicesValidationRules";

import {
  GENERATED,
  GENERATING,
  EXPORTED_TO_ACOMBA,
} from "./enums/invoiceStatuses";

class BasicDivisionFields extends React.Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  componentWillMount() {
    this.props.dataActions.getDataList(
      BILLING_PERIODS,
      0,
      0,
      "",
      ["startDate:desc"],
      [
        `clientId==${this.props.initialValues.clientId}`,
        "invoices.billingPeriodId==null",
      ]
    );
  }

  render() {
    const billingPeriods = this.props.billingPeriodsList
      .filter((billingPeriod) => {
        return (
          billingPeriod.invoiceStatusType !== GENERATED.value &&
          billingPeriod.invoiceStatusType !== GENERATING.value &&
          billingPeriod.invoiceStatusType !== EXPORTED_TO_ACOMBA.value
        );
      })
      .map((billingPeriod) => {
        return {
          value: billingPeriod.billingPeriodId,
          text: billingPeriod.localizations[this.props.authLanguageCode].name,
        };
      });
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="billingPeriodId"
          name="billingPeriodId"
          component={SelectInput}
          sortOptions={false}
          options={billingPeriods}
          addBlankOption={true}
          label={
            <FormattedMessage id="invoices.datatable.columns.billingPeriod" />
          }
        />
      </form>
    );
  }
}

BasicDivisionFields.propTypes = {
  billingPeriodsList: PropTypes.array,
  dataActions: PropTypes.object,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  authLanguageCode: PropTypes.string,
};

BasicDivisionFields.defaultProps = {
  scene: "",
};

BasicDivisionFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicDivisionFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  const billingPeriodsData = state.data.billingPeriods || {};
  return {
    billingPeriodsList: billingPeriodsData.items || [],
    authLanguageCode: state.auth.user.languageCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "invoice",
    validate: (values) =>
      validationUtils.validate(values, INVOICES_VALIDATION_RULES),
  })(BasicDivisionFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/BasicInvoiceFields.js